module.exports = __webpack_public_path__ + "img/verrière porte ouverte.87fb423b.jpg";